import { DOCUMENT } from '@angular/common';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';

import { MobileAuthService, MobileReputationService } from '@sifca-monorepo/clients';

@Component({
  template: '',
})
export class MobileAppComponent {
  constructor(
    protected cdr: ChangeDetectorRef,
    protected translate: TranslateService,
    protected authService: MobileAuthService,
    protected reputationService: MobileReputationService,
    @Inject(DOCUMENT) protected document: Document,
  ) {
    if (Capacitor.getPlatform() !== 'web') {
      this.authService.registerPush();
    }
    const lang = localStorage.getItem('elvklang');
    if (lang) {
      this.translate.use(lang);
      this.applyDocumentLanguage(lang);
    } else {
      localStorage.setItem('elvklang', 'fr-fr');
      this.translate.use('fr-fr');
      this.applyDocumentLanguage('fr-fr');
    }
    this.translate.onLangChange.subscribe((event) => {
      this.applyDocumentLanguage(event.lang);
    });
    const accessToken = localStorage.getItem('elvkwdigttoken');
    if (accessToken) {
      this.authService.getWidgetUserForTarget().subscribe();
    }
    // Dynamically load Google Identity Services (for google.accounts.*)
    const googleScriptUrl = 'https://accounts.google.com/gsi/client';
    if (!this.document.querySelector(`script[src="${googleScriptUrl}"]`)) {
      const googleScript = this.document.createElement('script');
      googleScript.src = googleScriptUrl;
      googleScript.async = true;
      googleScript.defer = true;
      this.document.body.appendChild(googleScript);
    }
    this.cdr.markForCheck();
  }

  protected applyDocumentLanguage(lang: string): void {
    const isRtl = lang === 'ar-sa' || lang === 'ar-tn' || lang.startsWith('ar');
    this.document.documentElement.lang = lang;
    this.document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  }
}
